// walk-move-trigger.ts — MV8 (2026-10-08, R-008 `move-trigger`): a WALK's triggers_on_move tail on the Force Move's own planner. The legacy
// walk fires the mover's triggers_on_move ONCE in final_creature_move (L661–683, planar displacement > 0.01 ft) with the mover at its landing;
// move-trigger-truth.ts (lane A's — called, never edited) resolves that tail synchronously before the move commits and commits it after the
// landing is saved. Registered with movement-truth.ts (an import there would close a cycle: move-trigger-truth.ts imports movement-truth.ts).
import { commitMoveTriggers, planMoveTriggers } from './move-trigger-truth.js';
import { registerWalkMoveTriggerPlanner } from './movement-truth.js';

registerWalkMoveTriggerPlanner({
  plan(encounterId, moverId, landing) {
    // a walk's enters-reach triggers fire per foot inside the legacy loop (the scope proves or hands them back) — only the mover's own tail here
    const planned = planMoveTriggers(encounterId, moverId, { onMove: true, entered: [] }, landing);
    if (planned.kind === 'handback') return { kind: 'handback', reason: planned.reason };
    if (planned.kind === 'none') return { kind: 'none' };
    return { kind: 'planned', commit: (rev: number) => commitMoveTriggers(planned, rev) };
  },
});
